<template>
  <a-modal v-model="isShow" title="Search" @ok="onSearchSubmit">
    <a-input v-model="text" :placeholder="placeholder" />
    <div style="margin-top: 10px">
      <span style="color: #7f7f7f">{{ description }}</span>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    search: { type: Function },
    placeholder: String,
    description: String
  },
  components: {},
  data() {
    return {
      text: "",
      isShow: false
    };
  },
  methods: {
    onSearchSubmit() {
      this.isShow = false;
      this.search(this.text);
    },
    show() {
      this.isShow = true;
    },
    clearFilter() {
      this.text = "";
    }
  }
};
</script>

<style lang="scss"></style>
